/** @file Times and mapped values of a discrete channel (attachment, inherit, flags, draw order). */
import { sortKeysByFrame } from './sortKeysByFrame';

/** `t` in seconds; `map` converts each document value to its rig encoding. Discrete keys step (no curves). */
export function discreteTimeline<V, O>(keys: readonly { f: number; v: V }[], fps: number, map: (v: V) => O): { t: number[]; v: O[] } {
  const sorted = sortKeysByFrame(keys);
  return { t: sorted.map((k) => k.f / fps), v: sorted.map((k) => map(k.v)) };
}
